import React from 'react';
import {
  SPostCard,
  SPostCardFooter,
  SPostCardImage,
  SPostCardTitle,
  SCardCol,
  SPostReadTime,
  SLink,
  SExcerpt,
  SCategoryName,
  SReadMore,
  SPostAuthorContainer,
  SPostAuthorAvatar,
  SPostAuthorName,
  SPostCreatedDate,
  SPostCardImageBox,
} from './styles';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import AuthorSVG from 'images/svg/blog_author.svg';
import CalendarSVG from 'images/svg/calendar.svg';

/**
 *
 * This component has two versions: regular/inverse
 *
 * By default, the regular version is served
 * <BlogPostCard ...restProps />
 *
 * To turn on the inverse version
 *
 * <BlogPostCard inverse ...restProps />
 *
 */

const BlogPostCard = ({
  postUrl,
  imageAlt,
  mdCol = '6',
  lgCol = '3',
  postTitle,
  image,
  inverse,
  height,
  categories,
  excerpt,
  author,
  isPodcast,
  postDate,
  categoryBaseURL = '/blog/categories',
}) => {
  return (
    <SCardCol xs="12" md={mdCol} lg={lgCol} className="mb-4">
      {!isPodcast && categories && categories.length ? (
        <SCategoryName inverse={inverse}>
          <Link to={`${categoryBaseURL}/${categories[0].slug}/1/`}>
            {categories[0].name}
          </Link>
        </SCategoryName>
      ) : null}
      <SLink to={postUrl}>
        <SPostCardImageBox height={height}>
          {image && (
            <SPostCardImage height={height} image={image} alt={imageAlt} />
          )}
        </SPostCardImageBox>
      </SLink>
      <SPostCardFooter inverse={inverse}>
        <SPostAuthorContainer inverse={inverse}>
          {/* <SPostAuthorName>
            <AuthorSVG />
            <span className="content">
              Name
              {author.firstName} {author.lastName}
            </span>
          </SPostAuthorName> */}

          <SPostCreatedDate inverse={inverse}>
            <CalendarSVG />
            <span className="content">{postDate}</span>
          </SPostCreatedDate>
        </SPostAuthorContainer>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Link to={postUrl}>
            <SPostCardTitle>{postTitle}</SPostCardTitle>
          </Link>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <SExcerpt inverse={inverse}>{excerpt}</SExcerpt>

            <SReadMore to={postUrl}>
              {isPodcast ? 'Listen Now' : 'Read More'}
            </SReadMore>
          </div>
        </div>
      </SPostCardFooter>
    </SCardCol>
  );
};

BlogPostCard.propTypes = {
  postUrl: PropTypes.string,
  image: PropTypes.any,
  postDate: PropTypes.string,
  postTitle: PropTypes.string,
  imageAlt: PropTypes.string,
  lgCol: PropTypes.string,
  mdCol: PropTypes.string,
  inverse: PropTypes.bool,
  isPodcast: PropTypes.bool,
  postReadingTime: PropTypes.number,
  height: PropTypes.string,
  hideReadingTime: PropTypes.bool,
  titleLink: PropTypes.bool,
  author: PropTypes.object,
  categories: PropTypes.array,
  excerpt: PropTypes.string,
  categoryBaseURL: PropTypes.string,
};

export default BlogPostCard;
